<template>
    <div class="role-form">
        <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                    <div class="col-8">
                        <h3 class="mb-0">Role</h3>
                    </div>
                    <div class="col-4 text-right">
                        <router-link :to="'/roles/'">&laquo; Back to Roles</router-link>
                    </div>
                </div>
            </div>
            <template>
                <form @submit.prevent>
                    <div class="pl-lg-4">
                        <div class="row">
                            <div class="col-lg-6">
                                <base-input alternative=""
                                            label="Name"
                                            placeholder="Name"
                                            input-classes="form-control-alternative"
                                            v-model="model.name"
                                />
                            </div>
                            <div class="col-lg-6">
                                <base-input alternative=""
                                            label="Role"
                                            placeholder="Role"
                                            input-classes="form-control-alternative"
                                            :disabled="model.id > 0"
                                            v-model="model.role"
                                />
                            </div>
                        </div>
                    </div>

                    <hr class="my-4" />

                    <h6 class="heading-small text-muted mb-4">Admin Functionalities</h6>

                    <h7 class="heading-small text-muted ml-3">Engineering</h7>
                    <div class="pl-lg-4">
                        <div class="row">
                            <div class="col-lg-12">
                                <base-checkbox class="custom-control-alternative" :name="'functions'" :value="'engr_db'" :checked="inFunction('engr_db')">Edit Engineering Database</base-checkbox>
                            </div>
                            <div class="col-lg-12">
                                <base-checkbox class="custom-control-alternative" :name="'functions'" :value="'engr_3d'" :checked="inFunction('engr_3d')">Edit Viewable 3d Models</base-checkbox>
                            </div>
                        </div>
                    </div>

                    <br>

                    <h7 class="heading-small text-muted ml-3">User Management</h7>
                    <div class="pl-lg-4">
                        <div class="row">
                            <div class="col-lg-12">
                                <base-checkbox class="custom-control-alternative" :name="'functions'" :value="'user_export'" :checked="inFunction('user_export')">Export full user list</base-checkbox>
                            </div>
                            <div class="col-lg-12">
                                <base-checkbox class="custom-control-alternative" :name="'functions'" :value="'user_job_vacancies'" :checked="inFunction('user_job_vacancies')">Adjust Job Vacancies</base-checkbox>
                            </div>
                            <div class="col-lg-12">
                                <base-checkbox class="custom-control-alternative" :name="'functions'" :value="'user_edit'" :checked="inFunction('user_edit')">Edit Users</base-checkbox>
                            </div>
                            <div class="col-lg-12">
                                <base-checkbox class="custom-control-alternative" :name="'functions'" :value="'user_edit_bulk'" :checked="inFunction('user_edit_bulk')">Users Bulk Edit</base-checkbox>
                            </div>
                        </div>
                    </div>

                    <br>

                    <h7 class="heading-small text-muted ml-3">Marketing and Sales</h7>
                    <div class="pl-lg-4">
                        <div class="row">
                            <div class="col-lg-12">
                                <base-checkbox class="custom-control-alternative" :name="'functions'" :value="'mas_1'" :checked="inFunction('mas_1')">Export full quote list</base-checkbox>
                            </div>
                            <div class="col-lg-12">
                                <base-checkbox class="custom-control-alternative" :name="'functions'" :value="'mas_2'" :checked="inFunction('mas_2')">Export full user list</base-checkbox>
                            </div>
                            <div class="col-lg-12">
                                <base-checkbox class="custom-control-alternative" :name="'functions'" :value="'mas_3'" :checked="inFunction('mas_3')">Edit Questionnaires</base-checkbox>
                            </div>
                            <div class="col-lg-12">
                                <base-checkbox class="custom-control-alternative" :name="'functions'" :value="'mas_4'" :checked="inFunction('mas_4')">Adjust Job Vacancies</base-checkbox>
                            </div>
                        </div>
                    </div>

                    <br>

                    <h7 class="heading-small text-muted ml-3">Projects</h7>
                    <div class="pl-lg-4">
                        <div class="row">
                            <div class="col-lg-12">
                                <base-checkbox class="custom-control-alternative" :name="'functions'" :value="'proj_submit'" :checked="inFunction('user_export')">Can Submit Quotes</base-checkbox>
                            </div>
                            <div class="col-lg-12">
                                <base-checkbox class="custom-control-alternative" :name="'functions'" :value="'proj_purchase'" :checked="inFunction('user_job_vacancies')">Can Purchase</base-checkbox>
                            </div>
                            <div class="col-lg-12">
                                <base-checkbox class="custom-control-alternative" :name="'functions'" :value="'proj_order'" :checked="inFunction('user_job_vacancies')">Can Order</base-checkbox>
                            </div>
                        </div>
                    </div>

                    <hr class="my-4" />

                    <a @click="saveRole" class="btn">Save</a>
                </form>
            </template>
        </card>
    </div>
</template>
<script>
  export default {
    name: 'roles',
    data() {
      return {
        apiUrl: '/api/',
        model: {},
        functions: [],
      }
    },
    created() {
        var user = localStorage.getItem('user');
        if ( !user ) this.$router.push('login');
        this.user = JSON.parse(user);

        const role_id = this.$route.params.id;
        if ( role_id > 0 ) this.getRole(role_id);
    },
    methods: {
        inFunction(role) {
            if ( !this.model.functions ) return false;
            const functions = this.model.functions.split(',');
            return functions.includes(role);
        },
        saveRole() {
            console.log(this.functions.join(','));
        },
        getRole(role_id) {
            const api = this.apiUrl+'role/'+role_id;
            this.isLoading = true;
            this.$http.get(api).then((response) => {
                this.isLoading = false;
                this.model = response.data;
            });
        },
    }
  };
</script>
<style>
  .roles-list .projects-table { max-width: 100%; }
  .roles-list .projects-table th, .roles-list .projects-table td{ text-align: left; white-space: normal; }
  .roles-list .projects-table th{ text-align: center; background: #000; color: #FFF; }
  .role-form .btn-wrap{ white-space: nowrap; margin-top: 4px; }
  .role-form .btn{
    border-radius: 0;
    width: 120px;
    padding: 7px;
    border: 0;
    letter-spacing: .3px;
    color: #fff;
    font-size: 11px;
    text-decoration: none;
    background: #5bc0de;
    display: inline-block;
  }
  .roles-list .btn-success{ background: #5cb85c; }
  .roles-list .projects-table .vtop{ vertical-align: top; }
  .roles-list .projects-table .vright{ text-align: right; }
</style>
